<template>
    <div>
        <!-- 格式转换按钮 -->
        <div class="mt-2">
            <label for="change-format"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="格式转换" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1704704621435" class="icon fill-current w-16 h-6" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="3438" width="200" height="200">
                        <path
                            d="M136.192 986.112C66.56 986.112 10.24 927.744 10.24 856.576v-141.312c0-71.68 56.32-130.048 125.952-130.048h241.664c69.632 0 125.952 58.368 125.952 130.048v141.312c0 71.68-56.32 130.048-125.952 130.048H136.192z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272v-141.312c0-29.696-23.552-54.272-52.224-54.272H136.192z m485.888 308.736c-19.968 0-31.232-15.872-31.744-31.232-0.512-14.848 8.192-32.768 35.84-35.328 26.112-4.608 46.08-8.704 70.144-16.896l1.024-0.512h1.024c9.216 0 40.448-22.528 66.56-53.76l0.512-1.024 1.536-1.024h0.512c14.336-7.168 38.912-48.64 51.712-96.256 0.512-3.072 1.024-5.632 1.536-8.192l0.512-2.56c3.072-16.896 6.144-31.744 6.144-49.152 0-2.048 0-5.12-0.512-10.24-0.512-3.072-0.512-5.632-0.512-8.704l-37.376 45.568c-9.728 10.752-18.944 12.8-25.088 12.8-4.096 0-8.704-1.024-12.8-3.072-9.728-5.12-15.36-11.776-17.408-20.48-2.56-11.264 3.584-21.504 6.144-25.088l0.512-0.512 84.992-105.472c3.072-3.072 20.48-19.456 38.912-19.456 26.112 0 40.448 23.04 44.032 29.184l76.288 110.08s12.288 17.408-9.216 39.936c-7.168 7.168-15.36 11.264-23.04 11.264-9.728 0-15.872-5.632-16.896-6.656l-42.496-56.832v16.896c0 60.928-20.48 119.808-60.928 175.104-40.448 50.688-86.528 83.456-140.8 101.376-2.048 1.024-5.12 2.048-13.312 4.096l-4.096 1.024c-12.288 3.072-23.552 5.12-33.28 6.656h-18.432z m-456.704-451.584c-28.672 0-43.008-26.624-44.544-30.208l-71.68-113.152s-12.288-17.408 9.216-39.424c7.68-7.168 15.36-11.264 23.04-11.264 9.728 0 15.872 5.632 16.896 6.656l42.496 56.32v-1.536-6.144c0.512-25.6 3.584-51.2 8.704-75.776 11.776-48.64 38.912-94.208 82.432-139.776 41.984-38.912 90.624-64 139.776-72.192 17.408-4.608 34.816-4.608 52.224-4.608 9.728 0 15.36 13.312 15.872 26.112 1.024 17.92-7.68 37.888-35.84 40.96l-2.048 0.512c-19.968 4.096-40.448 8.192-59.904 16.384-38.4 15.872-67.584 39.936-94.72 76.8l-4.608 6.656-2.048-1.536c-6.144 8.704-20.992 35.84-28.672 71.168l-0.512 3.072-0.512 1.536v0.512c-0.512 2.048-5.12 25.088-5.12 51.2v4.096c0 3.072 0.512 6.656 0.512 9.728 0 1.536 0 2.56 0.512 4.096l33.792-40.96c9.728-10.752 18.944-12.8 25.088-12.8 4.608 0 8.704 1.024 12.8 3.072 9.728 5.12 15.36 11.776 17.408 19.968 1.536 7.68-0.512 16.896-6.144 25.088v0.512L204.8 498.176c-3.584 3.584-20.992 19.968-39.424 19.968z m471.04-42.496c-69.632 0-125.952-58.368-125.952-130.048V204.8c0-71.68 56.32-130.048 125.952-130.048h241.152C947.2 74.752 1003.52 133.12 1003.52 204.8v141.312c0 71.68-56.32 130.048-125.952 130.048h-241.152z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272V204.8c0-29.696-23.552-54.272-52.224-54.272h-241.152z">
                        </path>
                    </svg>
                    <div v-if="detail" class="mr-auto">格式转换</div>
                </span>
            </label>
        </div>

        <!-- 分割音轨按钮 -->
        <div class="mt-2">
            <label for="split_cue"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="分割音轨" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg viewBox="0 0 16 14" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.00001 0.750244C6.00001 0.33603 5.66422 0.000244141 5.25001 0.000244141C4.83579 0.000244141 4.50001 0.336031 4.50001 0.750244L4.50001 1.10975C4.50001 1.72344 4.75068 2.31051 5.19395 2.73492L7.26701 4.71982L4.82988 7.09988C4.42039 7.49039 4.31633 8.10894 4.59285 8.61168L4.60292 8.63001L6.88601 12.2829C6.96051 12.4021 7.00001 12.5399 7.00001 12.6804V13.2502C7.00001 13.6645 7.33579 14.0002 7.75001 14.0002C8.16422 14.0002 8.50001 13.6645 8.50001 13.2502L8.50001 12.6804C8.50001 12.2587 8.3815 11.8455 8.158 11.4879L6.00724 8.04672L8.47876 5.63307C8.8733 5.28191 8.97223 4.73973 8.81074 4.29147C8.7162 4.02904 8.53253 3.85435 8.46556 3.79066L8.45717 3.78266L6.23132 1.65147C6.08357 1.51 6.00001 1.31431 6.00001 1.10975L6.00001 0.750244Z" />
                        <path
                            d="M2.5 1.75024C2.08421 1.75024 1.75 2.08446 1.75 2.50024V11.5002C1.75 11.916 2.08421 12.2502 2.5 12.2502H5.25C5.66421 12.2502 6 12.586 6 13.0002C6 13.4145 5.66421 13.7502 5.25 13.7502H2.5C1.25579 13.7502 0.25 12.7445 0.25 11.5002V2.50024C0.25 1.25603 1.25579 0.250244 2.5 0.250244H3.11C3.52421 0.250244 3.86 0.586031 3.86 1.00024C3.86 1.41446 3.52421 1.75024 3.11 1.75024H2.5Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.47296 2.23137C7.87783 1.41306 8.4474 0.250244 9.47952 0.250244H13.4995C14.7437 0.250244 15.7495 1.25603 15.7495 2.50024V11.5002C15.7495 12.7445 14.7437 13.7502 13.4995 13.7502H11.1795C10.7359 13.7502 10.302 13.5087 10.0856 13.0893L7.90236 9.06168L7.90098 9.05917C7.63468 8.57234 7.71835 7.95284 8.13705 7.5617L10.6534 4.96992L8.48264 2.24467L8.47296 2.23137ZM10.0065 1.75024L11.9884 4.23833L11.9998 4.25432C12.3627 4.7623 12.2997 5.45211 11.8588 5.88178L9.30861 8.50837L11.337 12.2502H13.4995C13.9153 12.2502 14.2495 11.916 14.2495 11.5002V2.50024C14.2495 2.08446 13.9153 1.75024 13.4995 1.75024H10.0065Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">分割音轨</div>
                </span>
            </label>
        </div>

        <!-- 导入收藏按钮 -->
        <div class="mt-2">
            <button :theme="'success'" onclick="import_music.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="导入收藏">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="import-music" class="w-16 h-6 fill-current" />
                    <div v-if="detail" class="mr-auto">导入收藏</div>
                </span>
            </button>
        </div>

        <!-- 重复文件检查按钮 -->
        <div class="mt-2">
            <button :theme="'success'" onclick="dup_check.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="重复文件检查" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="duplicate-file" class="w-16 h-6 fill-current" />
                    <div v-if="detail" class="mr-auto">重复文件检查</div>
                </span>
            </button>
        </div>

        <!-- 回放增益按钮 -->
        <div class="mt-2">
            <button :theme="'success'" onclick="gain.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="回放增益" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="gain" class="w-16 h-6 fill-current" />
                    <div v-if="detail" class="mr-auto">回放增益</div>
                </span>
            </button>
        </div>

        <!-- 生成strm文件按钮 -->
        <div class="mt-2">
            <button :theme="'success'" @click="generateStrmModal"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="生成 strm 文件" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="cloud-down" class="w-16 h-8 fill-current" />
                    <div v-if="detail" class="mr-auto">生成strm文件</div>
                </span>
            </button>
        </div>

        <!-- 生成strm文件 Modal -->
        <dialog ref="generate_strm" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">生成strm文件</h3>
                <div>
                    <div class="text-gray-400">将歌曲转换为strm文件</div>
                </div>
                <div>
                    <div class="mt-2">保存目录</div>
                    <input type="text" class="input input-bordered input-sm w-full max-w-xs" v-model="saveDir" />
                    <div class="text-gray-400 text-sm">保存目录，默认保存到当前目录</div>

                    <div class="mt-2">是否签名</div>
                    <input type="checkbox" class="toggle" v-model="isSign" />
                    <div class="text-gray-400 text-sm">OpenList开启签名，需要开启签名</div>
                    <div class="text-gray-400 text-sm">开启签名扫描速度会慢一些</div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-neutral btn-sm mr-2" @click="generateStrm" v-if="userRole === 'V2'">确认</button>
                        <button class="btn btn-neutral btn-sm mr-2" v-else>确认(V2功能)</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 回放增益 Modal -->
        <dialog id="gain" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">回放增益</h3>
                <div>
                    <div class="text-gray-400">通过扫描各个文件的音量大小，再将回放增益信息写入各个文件的属性标签中，播放的时候通过回放增益统一音量大小</div>
                    <div class="text-gray-400">需要下载<a href="https://johnvansickle.com/ffmpeg/" target="_blank"
                            style="color: blue;">ffmpeg</a>可执行文件
                    </div>
                    <div class="text-gray-400">放置在挂载的 /app/data/bin/ 目录下</div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleReplayGain" v-if="userRole === 'V2'">确认</button>
                        <button class="btn btn-neutral btn-sm mr-2" v-else>确认(V2功能)</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 重复文件检查 Modal -->
        <dialog id="dup_check" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">重复文件检查</h3>
                <div class="py-4">
                    <div>
                        <div class="text-gray-400">查找出重复的文件</div>
                        <div class="text-gray-400">不会自动删除您的文件，可以到操作记录中查看重复文件进一步删除操作。</div>
                        <div class="text-gray-400">支持根据hash校验重复和文件名称校验重复</div>
                        <div>
                            <div class="mt-2">是否启用声纹重复校验</div>
                            <input type="checkbox" class="toggle" v-model="isAcoustid" />
                            <div class="text-gray-400">声纹重复检验,重复文件即使hash不同也会被识别为重复</div>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-neutral btn-sm mr-2" @click="checkForDuplicates" v-if="userRole === 'V2'">确认</button>
                        <button class="btn btn-neutral btn-sm mr-2" v-else>确认(V2功能)</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 导入收藏 Modal -->
        <dialog id="import_music" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">导入收藏</h3>
                <div class="py-4">
                    <div class="text-gray-400">将勾选的音乐导入音乐收藏库</div>
                    <div>
                        <div class="mt-2">跳过已入库的音乐文件:</div>
                        <div class="flex items-center">
                            <input type="checkbox" class="toggle toggle-primary mr-2" v-model="isSkipExist" />
                            <div v-if="isSkipExist">是</div>
                            <div v-else>否</div>
                        </div>
                        <div class="mt-2">导入速率:</div>
                        <div>
                            <input type="number" class="input input-bordered input-sm w-full max-w-xs"
                                v-model="importRate" />
                            <div class="text-gray-400">每秒导入的音乐文件数量, 基于你机器的性能。</div>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-neutral btn-sm mr-2" @click="importMusic" v-if="userRole === 'V2'">确认</button>
                        <button class="btn btn-neutral btn-sm mr-2" v-else>确认(V2功能)</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 格式转换 Drawer -->
        <div class="drawer">
            <input id="change-format" type="checkbox" class="drawer-toggle" v-model="formatMusicCheckBox" />
            <div class="drawer-content"></div>
            <div class="drawer-side">
                <label for="change-format" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">格式转换</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="formatMusicFunc">确认</button>
                            <button class="btn btn-sm ml-1" @click="formatMusicCheckBox = false">取消</button>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="text-gray-400">将音频转换成其他格式，保存在同目录下。</div>
                            <div class="text-gray-400">不会删除源文件</div>
                            <div class="text-gray-400">需要下载<a href="https://johnvansickle.com/ffmpeg/" target="_blank"
                                    style="color: blue;">ffmpeg</a>可执行文件
                            </div>
                            <div class="text-gray-400">放置在挂载的 /app/data/bin/ 目录下</div>
                        </div>

                        <div style="margin-top: 10px;margin-bottom: 5px;">目标格式</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectFormat">
                            <option v-for="option in formatList" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div style="margin-top: 10px;margin-bottom: 5px;">比特率</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectBitRate">
                            <option v-for="option in bitRateList" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div v-if="selectBitRate === 'custom'">
                            <div style="margin-top: 10px;margin-bottom: 5px;">自定义</div>
                            <input type="text" placeholder="请输入自定义的比特率"
                                class="input input-bordered input-sm w-full max-w-xs" v-model="selectBitRateCustom" />
                        </div>

                        <div style="margin-top: 10px;margin-bottom: 5px;">采样率</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectSampleRate">
                            <option v-for="option in sampleRateList" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div v-if="selectSampleRate === 'custom'">
                            <div style="margin-top: 10px;margin-bottom: 5px;">自定义</div>
                            <input type="text" placeholder="请输入自定义的采样率"
                                class="input input-bordered input-sm w-full max-w-xs"
                                v-model="selectSampleRateCustom" />
                            <p class="text-gray-400 text-sm">必须是目标格式支持的有效采样率值，否则将转换失败。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分割音轨 Drawer -->
        <div class="drawer">
            <input id="split_cue" type="checkbox" class="drawer-toggle" v-model="splitCueCheckBox" />
            <div class="drawer-content"></div>
            <div class="drawer-side">
                <label for="split_cue" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">切分音轨</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="splitCueFunc">确认</button>
                            <button class="btn btn-sm ml-1" @click="splitCueCheckBox = false">取消</button>
                        </div>
                    </div>
                    <div>
                        <div class="py-4 text-gray-400">
                            <div>使用CUE标记文件无损切割整轨CD音轨</div>
                            <div>不会删除源文件</div>
                            <div>需要下载<a href="https://johnvansickle.com/ffmpeg/" target="_blank"
                                    style="color: blue;">ffmpeg</a>可执行文件
                            </div>
                            <div>放置在挂载的 /app/data/bin/ 目录下</div>
                        </div>
                        <div>目标格式</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectCueFormat">
                            <option v-for="option in formatList2" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div class="mt-2">是否删除源文件</div>
                        <input type="checkbox" class="toggle toggle-md toggle-primary" v-model="isDeleteSource">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';

export default {
    name: 'MediaProcessor',
    components: { SvgIcon },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        checkedData: {
            type: Array,
            default: () => []
        },
        filePath: {
            type: String,
            default: ''
        },
        userRole: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selectFormat: '',
            selectCueFormat: '',
            isDeleteSource: false,
            formatList: [
                { id: '', name: '维持原格式' },
                { id: 'mp3', name: 'MP3' },
                { id: 'wav', name: 'WAV' },
                { id: 'flac', name: 'FLAC' },
                { id: 'wma', name: 'WMA' },
                { id: 'ogg', name: 'OGG' }
            ],
            formatList2: [
                { id: '', name: '维持原格式' },
                { id: 'mp3', name: 'MP3' },
                { id: 'wav', name: 'WAV' },
                { id: 'flac', name: 'FLAC' },
                { id: 'wma', name: 'WMA' },
                { id: 'ogg', name: 'OGG' }
            ],
            selectBitRate: '-1',
            selectBitRateCustom: '',
            bitRateList: [
                { id: '-1', name: '保持原样' },
                { id: '32', name: '32k' },
                { id: '64', name: '64k' },
                { id: '96', name: '96k' },
                { id: '128', name: '128k' },
                { id: '160', name: '160k' },
                { id: '192', name: '192k' },
                { id: '224', name: '224k' },
                { id: '256', name: '256k' },
                { id: '320', name: '320k' },
                { id: 'custom', name: '自定义' }
            ],
            selectSampleRate: '-1',
            selectSampleRateCustom: '',
            sampleRateList: [
                { id: '-1', name: '保持原样' },
                { id: '11025', name: '11025' },
                { id: '22050', name: '22050' },
                { id: '44100', name: '44100' },
                { id: '48000', name: '48000' },
                { id: 'custom', name: '自定义' }
            ],
            isKeepSource: true,
            isSign: false,
            saveDir: '',
            isAcoustid: false,
            isSkipExist: true,
            importRate: 10,
            splitCueCheckBox: false,
            formatMusicCheckBox: false
        }
    },
    methods: {
        formatMusicFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.formatMusic({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_type': this.selectFormat,
                'bit_rate': this.selectBitRate,
                'bit_rate_custom': this.selectBitRateCustom,
                'sample_rate': this.selectSampleRate,
                'sample_rate_custom': this.selectSampleRateCustom,
                'is_keep_source': this.isKeepSource
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        splitCueFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.splitCueMusic({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'is_delete_source': this.isDeleteSource,
                'target_format': this.selectCueFormat
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        importMusic() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.importMusicIn({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': {},
                'is_skip_exist': this.isSkipExist,
                'import_rate': this.importRate
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        checkForDuplicates() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.checkDuplicate({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'is_acoustid': this.isAcoustid
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        handleReplayGain() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.batchUpdateId3({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': {},
                'is_regainer': true
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                        url: '/#/log'
                    });
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        generateStrmModal() {
            if (this.saveDir === '') {
                this.saveDir = this.filePath
            }
            this.$refs.generate_strm.showModal()
        },

        generateStrm() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.generateStrm({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'is_sign': this.isSign,
                'save_dir': this.saveDir
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        }
    }
}
</script>

<style scoped>
.icon {
    @apply fill-current w-16;
}
</style>